import keycloakfetch from '../../functions/keycloakfetch';
import settings from '../../config/settings';
import {ColumnSortParams} from 'primereact/column';
import {CustomConfirmDialog} from '../global/CustomConfirmDialog';
import {Mapping, MappingType, removeMapping} from '../../redux/slices/MappingSlice';
import {FlstKennz} from './GlobalData';
import {FilterMatchMode, FilterOperator} from 'primereact/api';
import {ColumnObject, ColumnObjectType} from '../global/CustomDataTable';

export type Nullable<T> = T | null;

export async function getProjectGroups(projectId: string) {
    let retValue: any = [];
    const endpointStr = '/getProjectGroups?project_id=' + projectId;
    await keycloakfetch.get(settings.apiUrl + endpointStr).then(result => {
        if (result)
            retValue = result;
    });
    return retValue;
}

/* *********************************************************************************************************************
 * Files
 **********************************************************************************************************************/

export async function getFile(projectId: Nullable<string>, fileId: Nullable<string>): Promise<any> {
    let retValue: any = {};
    if (fileId === null)
        return {data: null};

    await keycloakfetch.get(settings.apiUrl + '/getFile?project_id=' + projectId + '&file_id=' + fileId).then(result => {
        if (result)
            retValue = result;
    });
    return retValue;
}

export async function getFiles(projectId: Nullable<string>): Promise<any> {
    let retValue: any = {};
    await keycloakfetch.get(settings.apiUrl + '/getFiles?project_id=' + projectId).then(result => {
        if (result)
            retValue = result;
    });
    return retValue;
}

export async function insertFile(data: any) {
    let retValue: any = [];
    await keycloakfetch.put(settings.apiUrl + '/insertFile', data).then((result) => {
        if (result)
            retValue = result;
    });
    return retValue;
}

export async function deleteFile(projectId: Nullable<string>, fileId: string) {
    let retValue: any = [];
    const data = {
        'project_id': projectId,
        'file_id': fileId
    };
    await keycloakfetch.delete(settings.apiUrl + '/deleteFile', data).then((result) => {
        if (result)
            retValue = result;
    });
    return retValue;
}

/** *********************************************************************************************************************
 * Stammdaten
 */

/* *********************************************************************************************************************
 * Locations
 **********************************************************************************************************************/

export interface Location {
    'epsg_code': Nullable<number>,
    'epsg_code_name': Nullable<string>,
    'geo_position': any,
    'geo_position_x': Nullable<number>,
    'geo_position_y': Nullable<number>,
    'geo_position_z': Nullable<number>,
    'location_zoom': Nullable<number>,
    'is_visible': boolean,
    'location_description': Nullable<string>,
    'location_id': string,
    'location_name': string,
    'project_id': string,
    'transformation': Nullable<string>,
    'custom_link': string
}

/*
Aktivieren wenn Postgis existiert
 */
export async function getEPSGCodes(projectId: string) {
    const retValue: any = [];

    /* await keycloakfetch.get(settings.apiUrl + '/getEPSGCodes?project_id=' + projectId).then(result => {
        if (result)
            retValue = result;
    });*/
    return retValue;
}

export async function getLocation(projectId: string, locationId: string | null) {
    let retValue: any = {};
    await keycloakfetch.get(settings.apiUrl + '/getLocation?project_id=' + projectId + '&location_id=' + locationId).then(result => {
        if (result)
            retValue = result[0];
    });
    return retValue;
}

export async function getLocations(projectId: string) {
    let retValue: any = [];
    await keycloakfetch.get(settings.apiUrl + '/getLocations?project_id=' + projectId).then(result => {
        if (result)
            retValue = result;
    });
    return retValue;
}

export async function updateLocation(data: any) {
    let retValue: any = [];
    await keycloakfetch.post(settings.apiUrl + '/updateLocation', data).then(result => {
        if (result)
            retValue = result;
    });
    return retValue;
}

export async function createLocation(data: any) {
    let retValue: any = [];
    await keycloakfetch.put(settings.apiUrl + '/createLocation', data).then(result => {
        if (result)
            retValue = result;
    });
    return retValue;
}

export async function deleteLocation(projectId: string, locationIds: string[]) {
    let retValue: any = [];
    await keycloakfetch.delete(settings.apiUrl + '/deleteLocation', {
        'project_id': projectId,
        'location_ids': locationIds
    }).then(result => {
        if (result)
            retValue = result;
    });
    return retValue;
}

let user: any = null;

export function getUserFromLocalStorage() {
    if (user === null) {
        console.log('getUserFromLocalStorage');
        user = JSON.parse(localStorage.getItem('user') as string);
        if (user.settings === null) {
            user.settings = {};
        }
    }
    // console.log('user', user);
    return user;
}

export async function setUserSettings(key: string, value: any, projectId?: string) {
    const tmp_user = getUserFromLocalStorage();
    if (typeof user.settings === 'undefined') return;
    if (projectId) {
        if (!tmp_user.settings[projectId]) {
            tmp_user.settings[projectId] = {};
        }

        tmp_user.settings[projectId][key] = value;
    } else {
        tmp_user.settings[key] = value;
    }

    await keycloakfetch.put(settings.apiUrl + '/updateUserSettings', tmp_user.settings).then(result => {
        if (result) {
            localStorage.setItem('user', JSON.stringify(tmp_user));

            user = JSON.parse(localStorage.getItem('user') as string);
        }
    });
}

export async function getImportedPersons(projectId: string) {
    let retValue: any = [];
    await keycloakfetch.get(settings.apiUrl + '/getPerson?project_id=' + projectId + '&gettmpdata=true').then(result => {
        if (result)
            retValue = result;
    });
    return retValue;
}

export async function getImportedParcels(projectId: string) {
    let retValue: any = [];
    await keycloakfetch.get(settings.apiUrl + '/getParcel?project_id=' + projectId + '&gettmpdata=true').then(result => {
        if (result)
            retValue = result;
    });
    return retValue;
}

export async function getSpatialBookmarks(projectId: string) {
    let retValue: any = [];
    await keycloakfetch.get(settings.apiUrl + '/getSpatialBookmarks?project_id=' + projectId).then(result => {
        if (result)
            retValue = result;
    });
    return retValue;
}

export async function getSpatialBookmark(projectId: string, bookmarkId: string) {
    let retValue: any = [];
    await keycloakfetch.get(settings.apiUrl + '/getSpatialBookmark?project_id=' + projectId + '&bookmark_id=' + bookmarkId).then(result => {
        if (result)
            retValue = result;
    });
    return retValue;
}

export async function getIsoCodes() {
    let retValue: any = [];
    await keycloakfetch.get(settings.apiUrl + '/getBundeslaenderCodes').then(result => {
        if (result)
            retValue = result;
    });
    return retValue;
}

export const sortColumn = (sort: ColumnSortParams) => {
    return sort.data.sort((a: any, b: any) => {

        let aTemp = a[sort.field] ? a[sort.field].length : 0;
        let bTemp = b[sort.field] ? b[sort.field].length : 0;

        return aTemp > bTemp ? (sort.order === 1 ? 1 : -1) : aTemp < bTemp ? (sort.order === 1 ? -1 : 1) : 0;
    });
};

export const groupBy = (arr: any, prop: any) => {
    var grouped: any = {};
    for (var i = 0; i < arr.length; i++) {
        var p = arr[i][prop];
        if (!grouped[p]) {
            grouped[p] = [];
        }
        grouped[p].push(arr[i]);
    }
    return grouped;
};

export const splitFlstkennz = (flstkennz: string): Nullable<FlstKennz> => {
    if (flstkennz && flstkennz.length >= 0) {

        let temp_b_land_iso = '';
        let temp_gemarkung = '';
        let temp_flstzaehler = '';
        let temp_flstnenner = '';
        let temp_flur = '';
        let temp_flstfolge = '';

        if (flstkennz.length >= 2) {
            temp_b_land_iso = flstkennz.substring(0, 2);
        }

        if (flstkennz.length >= 6) {
            temp_gemarkung = flstkennz.substring(0, 6);
        }
        if (flstkennz.length >= 9) {
            temp_flur = flstkennz.substring(6, 9);
        }
        if (flstkennz.length >= 14) {
            temp_flstzaehler = flstkennz.substring(9, 14);
        }
        if (flstkennz.length >= 18) {
            temp_flstnenner = flstkennz.substring(14, 18);
        }
        if (flstkennz.length >= 2) {
            temp_flstfolge = flstkennz.substring(18, 20);
        }
        return {
            b_land_iso: temp_b_land_iso,
            b_land_name: '',
            gemarkung: temp_gemarkung,
            flur: temp_flur,
            flstzaehler: temp_flstzaehler,
            flstnenner: temp_flstnenner,
            flstfolge: temp_flstfolge
        };
    }
    return null;
};

export const combineFlstkennz = (flstInfos: FlstKennz): string => {
    let result = '';

    result = flstInfos.gemarkung + flstInfos.flur + flstInfos.flstzaehler + flstInfos.flstnenner + flstInfos.flstfolge;

    return result;
};

export enum MobileDevice {
    iOS,
    Android,
    WindowsPhone,
    Unkown
}

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 *
 * @returns {String}
 */
export const getMobileOperatingSystem = (): MobileDevice => {
    //@ts-ignore
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return MobileDevice.WindowsPhone;
    }

    if (/android/i.test(userAgent)) {
        return MobileDevice.Android;
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    //@ts-ignore
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return MobileDevice.iOS;
    }

    return MobileDevice.Unkown;
};

export const getGeoLocation = (func: (position: any) => void) => {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(func);
    } else {
        alert('Geolocation is not supported by this browser.');
    }
};

export const openGoogleMaps = (from: string, to: string) => {
    window.open(`https://www.google.de/maps/dir/${from}/${to}/`, '_blank');
};

export const openAppleMaps = (from: string, to: string) => {
    window.open(`http://maps.apple.com/?saddr=${from}&daddr=${to}`, '_blank');
};

export const onClickShowMap = (setShowMap: (prevState: any) => void) => {
    setShowMap((prevState: any) => {
        localStorage.setItem('showMap', (!prevState).toString());
        return !prevState;
    });
};

export const saveCheck = (t: any, func: () => void) => {
    return CustomConfirmDialog({
        header: t('common:dialogs.saveChangesHeader'),
        message: t('common:dialogs.saveChangesMessage'),
        translation: t,
        onConfirm: () => {
            func();
        },
        rejectClassName: 'float-right p-button-secondary'
    });
};

const replaceInvalidValues = (value: any) => {
    switch (value) {
        case (undefined):
        case '':
        case '':
            value = null;
            break;
    }
    return value;
};

export const iterateOverKeys = (data: any) => {
    const dataKeys = Object.keys(data);
    dataKeys.forEach((key: string) => {
        const entry = data[key];
        data[key] = replaceInvalidValues(entry);
    });

    return data;
};

export const addIdToHash = (id: string) => {
    let split = window.location.hash.split('_');

    if (split.length >= 2) {
        window.location.hash = split[0] + '_' + split[1] + '_' + id;
    }
};

export const removeIdFromHash = () => {
    let split = window.location.hash.split('_');

    if (split.length >= 2) {
        window.location.hash = split[0] + '_' + split[1];
    }
};


export const getFilter = (name: string, args?: any) => {
    return {
        [name]: {
            operator: FilterOperator.AND,
            constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}],
            ...args
        }
    };
};

export const getColumn = (t: any, field: string, localePre: string, filter = true, display = true, type?: ColumnObjectType, dateFormat?: string, locale: string = field, filterField: string = field, body?: any) => {
    return {
        field: field,
        header: t(localePre + locale),
        filter: filter,
        filterField: filterField,
        display: display,
        type: type,
        dateFormat: dateFormat,
        body: body ? body : undefined
    };
};

export const getColumnWithArgs = (t: any, field: string, localePre: string, filter = true, display = true, args?: any) => {
    return {
        field: field,
        header: t(localePre + field),
        filter: filter,
        display: display,
        ...args
    };
};

const convertToCSV = (data: any, dataTable_id: string, columns: any) => {
    const settings = getUserFromLocalStorage().settings;
    let displaySettings: any = settings['display_' + dataTable_id];

    let tmp;

    if (displaySettings && displaySettings.length > 0) {
        tmp = columns.filter((col: any) => displaySettings.indexOf(col.field) >= 0);
    } else {
        tmp = columns.filter((col: any) => col.display === true || col.display !== false);
    }

    let columnOrder: string[] = settings['columnorder_' + dataTable_id];

    if (columnOrder && columnOrder.length > 0) {
        tmp.sort((a: any, b: any) => {
                return columnOrder.indexOf(a.field) > columnOrder.indexOf(b.field) ? 1 : -1;
            }
        );
    }

    const selectedColumns = tmp;

    const rows = [];
    const csvSeparator = ';';

    // 1. Add header row
    let header = '';
    columns && selectedColumns.length > 0 && selectedColumns.map((column: ColumnObject) => {
        header += column.header + csvSeparator;
    });
    // Füge die Header-Zeile hinzu. Entferne aber das letzte Komma, da es überflüssig ist
    rows.push(header.slice(0, -1));

    // 2. Add data rows
    data.forEach((row: any) => {
        // Filtere nur die Spalten, die im Objekt vorhanden sind
        const filteredColumns = selectedColumns.filter((column: any) => Object.keys(row).includes(column.field));
        // Extrahiere die Werte in der Reihenfolge der gefilterten Spalten
        const values = filteredColumns.map((column: any) => row[column.field]);
        // Erstelle die Semikolon-separierte Zeichenkette
        rows.push(values.join(csvSeparator));
    });

    return rows.join('\n');
};

export const exportCSV = (t: any, value: any, dataTable_id: string, columns: any) => {
    // eslint-disable-next-line new-cap
    CustomConfirmDialog({
        message: t('customDataTable:dialogs.exportAsCSVDialog.message'),
        header: t('confirmation'),
        translation: t,
        onConfirm: () => {
            const data = convertToCSV(value, dataTable_id, columns);

            // Create a Byte Order Mark, so that excel will use UTF-8 instead of ANSI for encoding
            // https://stackoverflow.com/questions/42462764/javascript-export-csv-encoding-utf-8-issue
            const universalBOM = '\uFEFF';
            const blob = new Blob([universalBOM + data], {type: 'text/csv;charset=utf-8;'});
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.setAttribute('href', url);
            link.setAttribute('download', 'data.csv');
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    });
};
